import "./src/styles/global.css";
import { persistAdSource } from "./src/utils/adSource";

export const onRouteUpdate = ({ location }) => {
  persistAdSource(location.search);
};
